export default __webpack_public_path__ + "static/media/linode.3ab37103.svg";